import { trimEnd } from 'lodash-unified'
import { useEffect } from 'react'

const hashString = async (str: string) => {
  const encoder = new TextEncoder()
  const data = encoder.encode(str)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  return Array.from(new Uint8Array(hashBuffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('')
}

const checkForUpdates = async () => {
  try {
    const res = await fetch(`${trimEnd(import.meta.env.VITE_APP_BASE, '/')}/index.html`, { cache: 'no-store' })
    if (!res.ok) throw new Error('请求失败')

    const text = await res.text()
    const newHash = await hashString(text)

    const oldHash = localStorage.getItem('indexHash')
    if (oldHash && newHash !== oldHash) {
      jInfo('检测到新版本，刷新页面')
      localStorage.setItem('indexHash', newHash)
      caches.keys().then(keys => keys.forEach(key => caches.delete(key)))
      window.location.reload()
    } else {
      localStorage.setItem('indexHash', newHash)
    }
    jLog('检查更新成功')
  } catch (error) {
    jError('检查更新失败:', error)
  }
}

/**
 * 检查更新
 * @param interval 检查间隔时间（秒）
 */
const useCheckUpdates = (interval = 60) => {
  useEffect(() => {
    if (!__DEV__) {
      checkForUpdates()
      const timer = setInterval(checkForUpdates, interval * 1000)
      return () => clearInterval(timer)
    }
  }, [interval])
}

export default useCheckUpdates
